import React from 'react';

import CodeLightV2Controls from './robot__code-light-v2-controls';
import DefaultControls from './robot__controls';

type Props = {
    variant?: 'default' | 'code_light_v2';
};
const RobotControls = ({ variant = 'default' }: Props) => {
    switch (variant) {
        case 'code_light_v2':
            return <CodeLightV2Controls />;
        default:
            return <DefaultControls />;
    }
};

export default RobotControls;
